import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchHeadBand, showHeadBand, hideHeadBand } from '@app/src/common/headBand';
import { Wrapper, Title, Message, IconWrapper } from './styled';
import { Icon } from '@app/src/common/Icon';

export const HeadBand: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const headBandData = useSelector(state => state.headBand.data);
  const isShow = useSelector(state => state.headBand.show);

  useEffect(() => {
    if (headBandData && Object.keys(headBandData).length === 0) {
      dispatch(fetchHeadBand());
    }
    if (headBandData && Object.keys(headBandData).length > 0) {
      dispatch(showHeadBand(Boolean(headBandData && headBandData.state)));
    }
  }, [headBandData]);

  const handleClick = (e) => {
    e.stopPropagation();
    dispatch(hideHeadBand());
  };

  const handleClickHref = (e) => {
    e.preventDefault();
    history.push(headBandData && headBandData.url);
  };

  return (
    <React.Fragment>
      {
        isShow ?
        <Wrapper id="headBand" href="#" onClick={handleClickHref}>
          { headBandData && <Title>{headBandData.label}</Title>}
          <Message>{headBandData && headBandData.description}</Message>
          <IconWrapper onClick={handleClick}>
            <Icon data-name="icon-close-bold" width="12" height="12" fill="#000" />
          </IconWrapper>
        </Wrapper>
        :
        null
      }
    </React.Fragment>
  )
};
